import type { ReactNode } from 'react'

import { type PackageScope } from '@/models/vault'
import { AuditPackageButton } from './AuditPackageButton'

/** One band of the vault's front page: its name, its download, and the table, in one surface. */
export function VaultSection({
  title,
  count,
  scope,
  children,
}: {
  title: string
  count?: number
  /** What this section's Download pulls: only the rows in this table. */
  scope: PackageScope
  children: ReactNode
}) {
  return (
    <section className="bg-surface flex flex-col rounded-lg border">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-b px-4 py-3">
        <h2 className="flex items-baseline gap-2 text-lg font-semibold">
          {title}
          {count !== undefined && <span className="text-muted-foreground text-sm font-normal">{count}</span>}
        </h2>
        <AuditPackageButton kind={scope} label="Download" />
      </div>
      <div className="px-4 py-1">{children}</div>
    </section>
  )
}
